export const TARGET_WIDTH = 420;
export const OUTSIDE_BACKGROUND = '#f5f5f5';

const MOBILE_UA = /iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i;

export function isDesktopBrowser(navigatorObject) {
  const ua = navigatorObject.userAgent || '';
  if (MOBILE_UA.test(ua)) {
    return false;
  }
  if (/iPad/i.test(ua)) {
    return false;
  }
  if (navigatorObject.platform === 'MacIntel' && navigatorObject.maxTouchPoints > 1) {
    return false;
  }
  if (/Android/i.test(ua)) {
    return false;
  }
  return true;
}

export function computePcFrame(clientWidth) {
  if (clientWidth <= TARGET_WIDTH) {
    return null;
  }
  return {
    scale: TARGET_WIDTH / clientWidth,
    marginLeft: (clientWidth - TARGET_WIDTH) / 2,
  };
}

export function mountPcFrame() {
  if (!isDesktopBrowser(window.navigator)) {
    return function stop() {};
  }

  const html = document.documentElement;
  const body = document.body;
  const originals = {
    background: html.style.background,
    overflowX: html.style.overflowX,
    width: body.style.width,
    transform: body.style.transform,
    transformOrigin: body.style.transformOrigin,
    marginLeft: body.style.marginLeft,
    marginBottom: body.style.marginBottom,
  };

  function restore() {
    html.style.background = originals.background;
    html.style.overflowX = originals.overflowX;
    body.style.width = originals.width;
    body.style.transform = originals.transform;
    body.style.transformOrigin = originals.transformOrigin;
    body.style.marginLeft = originals.marginLeft;
    if (!originals.marginLeft) {
      body.style.removeProperty('margin-left');
    }
    body.style.marginBottom = originals.marginBottom;
    if (!originals.marginBottom) {
      body.style.removeProperty('margin-bottom');
    }
  }

  function update() {
    const clientWidth = html.clientWidth;
    const frame = computePcFrame(clientWidth);
    if (!frame) {
      restore();
      return;
    }
    html.style.background = OUTSIDE_BACKGROUND;
    html.style.overflowX = 'hidden';
    body.style.width = clientWidth + 'px';
    body.style.transform = 'scale(' + frame.scale + ')';
    body.style.transformOrigin = 'top left';
    body.style.marginLeft = frame.marginLeft + 'px';
    body.style.marginBottom = body.scrollHeight * (frame.scale - 1) + 'px';
  }

  window.addEventListener('resize', update);
  update();

  let stopped = false;
  return function stop() {
    if (stopped) {
      return;
    }
    stopped = true;
    window.removeEventListener('resize', update);
    restore();
  };
}
